// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Account/components/CardBalance/CardBalance.css
// module id = 465
// module chunks = 0